/* Sainté - Outfit Inspo
   Filtrene (temaets faner), detaljedialogen og købsboksen i den.

   Detaljerne for hvert look ligger som <template> i kortet og klones ind
   i dialogen ved klik. Åbning lægger et historik-trin på (#handle), så
   telefonens tilbage-knap lukker looket i stedet for at forlade siden, og
   et delt link åbner det samme look. */

if (!customElements.get('sainte-inspo')) {
  customElements.define('sainte-inspo', class SainteInspo extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-inspo-grid]');
      this.dialog = this.querySelector('[data-inspo-dialog]');
      if (!this.grid || !this.dialog) return;

      this.items = Array.from(this.grid.querySelectorAll('[data-look]'));
      this.body = this.dialog.querySelector('[data-dialog-body]');
      this.item = null;
      this.pushed = false;

      this.onClick = this.onClick.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onPop = this.onPop.bind(this);
      this.onResize = this.onResize.bind(this);

      this.addEventListener('click', this.onClick);
      this.dialog.addEventListener('keydown', this.onKey);
      this.dialog.addEventListener('cancel', (e) => {
        e.preventDefault();
        if (this.dialog.classList.contains('is-shop-open')) return this.toggleShop(false);
        this.requestClose();
      });
      this.dialog.addEventListener('close', () => this.onForeignClose());
      window.addEventListener('popstate', this.onPop);
      window.addEventListener('resize', this.onResize, { passive: true });

      const row = this.querySelector('.si-grid--row');
      if (row) this.setupDrag(row);

      // Opslaget øverst er en almindelig detaljevisning, bare ikke i dialogen
      this.querySelectorAll('.si-feature .si-detail').forEach((d) => {
        this.fillDetail(d);
        this.setupGallery(d);
      });

      const params = new URLSearchParams(location.search);
      if (params.get('filter')) this.filter(params.get('filter'), false);

      // Delte links og annoncer: ?look=julie (anbefalet til annoncer) eller #julie
      if (!(window.Shopify && window.Shopify.designMode)) {
        const item = this.find(params.get('look') || this.hashHandle());
        if (item) this.open(item, 'replace');
      }
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPop);
      window.removeEventListener('resize', this.onResize);
      document.documentElement.classList.remove('si-lock');
    }

    // Annonceplatforme sætter parametre bag på linket, også efter et #
    hashHandle() {
      try { return decodeURIComponent(location.hash.slice(1)).split(/[?&]/)[0]; } catch (e) { return ''; }
    }

    find(handle) {
      return handle ? this.items.find((i) => i.dataset.look === handle) : null;
    }

    visible() {
      return this.items.filter((i) => !i.hidden);
    }

    onClick(e) {
      const filterBtn = e.target.closest('[data-filter]');
      if (filterBtn) return this.filter(filterBtn.dataset.filter, true);

      const link = e.target.closest('[data-look-open]');
      if (link) {
        // Cmd/ctrl-klik må gerne åbne looket i en ny fane via #-linket
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        return this.open(link.closest('[data-look]'), 'push');
      }

      const sizeBtn = e.target.closest('.si-size');
      if (sizeBtn) return this.toggleSize(sizeBtn);
      const buyBtn = e.target.closest('[data-buy-look]');
      if (buyBtn) return this.buy(buyBtn);

      if (e.target.closest('[data-shop-open]')) return this.toggleShop(true);
      if (e.target.closest('[data-shop-close]')) return this.toggleShop(false);

      if (e.target.closest('[data-look-close]')) return this.requestClose();
      if (e.target.closest('[data-look-prev]')) return this.step(-1);
      if (e.target.closest('[data-look-next]')) return this.step(1);
    }

    onKey(e) {
      if (e.target.closest('input, textarea, select')) return;
      if (this.dialog.classList.contains('is-shop-open')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1); }
    }

    onPop(e) {
      // Historik-trin fra os selv, eller et #handle skrevet/indsat i adressen
      const handle = (e.state && e.state.siLook) || this.hashHandle();
      if (handle && this.find(handle)) {
        const item = this.find(handle);
        if (item) this.open(item, 'none');
      } else if (this.dialog.open) {
        this.pushed = false;
        this.closeNow();
      }
    }

    /* Essential Cart Drawer lukker ALLE åbne <dialog> på siden, når den
       starter (og når den selv åbner). Rammer det et look, der lige er åbnet
       fra et delt link, eller mens kurven ikke er i gang, åbnes det igen.
       Er kurven derimod åben, får den lov at vinde. */
    onForeignClose() {
      if (this.closing) { this.closing = false; return; }
      setTimeout(() => {
        if (this.dialog.open || !this.item) return;
        if (this.otherOverlayOpen()) return this.cleanup();
        this.dialog.showModal();
        document.documentElement.classList.add('si-lock');
      }, 60);
    }

    otherOverlayOpen() {
      const html = document.documentElement;
      const cartOpen = Array.from(html.classList).some((c) => c.startsWith('essential-cart__') && c !== 'essential-cart__closed');
      return cartOpen || !!document.querySelector('dialog[open]:not([data-inspo-dialog])');
    }

    onResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.checkTall(), 120);
    }

    /* Forsiderækken kan trækkes med musen. Touch og trackpad overlades til
       browseren (momentum-swipe). Pointer capture sættes først når musen
       faktisk har flyttet sig, ellers lander et almindeligt klik på rækken
       i stedet for på kortet. Et træk må ikke ende med at åbne et look. */
    setupDrag(row) {
      let down = false, dragging = false, startX = 0, startLeft = 0, moved = false;
      row.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; dragging = false; moved = false;
        startX = e.clientX; startLeft = row.scrollLeft;
      });
      row.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        if (!dragging && Math.abs(dx) > 5) {
          dragging = true; moved = true;
          row.setPointerCapture(e.pointerId);
          row.classList.add('is-dragging');
        }
        if (dragging) row.scrollLeft = startLeft - dx;
      });
      const end = (e) => {
        if (!down) return;
        down = false;
        if (dragging) {
          dragging = false;
          row.classList.remove('is-dragging');
          if (row.hasPointerCapture(e.pointerId)) row.releasePointerCapture(e.pointerId);
        }
      };
      row.addEventListener('pointerup', end);
      row.addEventListener('pointercancel', end);
      row.addEventListener('click', (e) => {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
      row.addEventListener('dragstart', (e) => e.preventDefault());
    }

    /* ------------------------------------------------------------ Filtre */

    filter(key, updateUrl) {
      const buttons = Array.from(this.querySelectorAll('[data-filter]'));
      if (!buttons.some((b) => b.dataset.filter === key)) key = 'all';

      buttons.forEach((b) => {
        const on = b.dataset.filter === key;
        b.classList.toggle('active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      this.items.forEach((item) => {
        const cats = (item.dataset.cats || '').split(/\s+/);
        item.hidden = !(key === 'all' || cats.includes(key));
      });

      this.grid.classList.remove('is-filtering');
      void this.grid.offsetWidth;
      this.grid.classList.add('is-filtering');

      if (updateUrl) {
        const url = new URL(location.href);
        if (key === 'all') url.searchParams.delete('filter');
        else url.searchParams.set('filter', key);
        history.replaceState(history.state, '', url);
      }
    }

    /* ------------------------------------------------------------ Dialog */

    open(item, mode) {
      if (!item) return;
      const tpl = item.querySelector('template[data-look-detail]');
      if (!tpl) return;

      const wasOpen = this.dialog.open;
      this.dialog.classList.remove('is-shop-open');
      this.item = item;
      this.body.replaceChildren(tpl.content.cloneNode(true));
      this.dialog.scrollTop = 0;

      const detail = this.body.querySelector('.si-detail');
      if (detail && detail.dataset.name) this.dialog.setAttribute('aria-label', detail.dataset.name);

      this.updateBar();
      this.setupGallery();
      const detailEl = this.body.querySelector('.si-detail');
      if (detailEl) this.fillDetail(detailEl);

      if (wasOpen) {
        this.body.classList.remove('is-swapping');
        void this.body.offsetWidth;
        this.body.classList.add('is-swapping');
      } else {
        this.dialog.showModal();
        document.documentElement.classList.add('si-lock');
        const close = this.dialog.querySelector('[data-look-close]');
        if (close) close.focus({ preventScroll: true });
      }

      const url = new URL(location.href);
      url.searchParams.delete('look');
      url.hash = item.dataset.look;
      const state = { siLook: item.dataset.look };
      if (mode === 'push') {
        history.pushState(state, '', url);
        this.pushed = true;
      } else if (mode === 'replace') {
        history.replaceState(state, '', url);
      }

      requestAnimationFrame(() => this.checkTall());
      this.body.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => this.checkTall(), { once: true });
      });
    }

    step(dir) {
      if (!this.dialog.open || !this.item) return;
      const vis = this.visible();
      if (vis.length < 2) return;
      const i = vis.indexOf(this.item);
      const next = vis[(i + dir + vis.length) % vis.length];
      this.open(next, 'replace');
    }

    requestClose() {
      // Er looket åbnet herfra, fjernes historik-trinnet igen; popstate lukker
      if (this.pushed && history.state && history.state.siLook) {
        history.back();
        return;
      }
      const url = new URL(location.href);
      url.hash = '';
      history.replaceState(null, '', url.pathname + url.search);
      this.closeNow();
    }

    closeNow() {
      if (!this.dialog.open) return;
      this.closing = true;
      this.dialog.classList.remove('is-shop-open');
      this.dialog.close();
      const item = this.item;
      this.cleanup();
      if (this.afterClose) {
        const next = this.afterClose;
        this.afterClose = null;
        setTimeout(next, 60);
        return;
      }
      if (item) {
        const link = item.querySelector('[data-look-open]');
        const rect = item.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) item.scrollIntoView({ block: 'center' });
        // Fokus tilbage til kortet, så tastaturet ikke mister sin plads - men
        // markeret, så CSS'en kan skjule den blå fokusramme indtil man tabber
        if (link) {
          link.setAttribute('data-restored', '');
          link.addEventListener('blur', () => link.removeAttribute('data-restored'), { once: true });
          link.focus({ preventScroll: true });
        }
      }
    }

    cleanup() {
      document.documentElement.classList.remove('si-lock');
      this.pushed = false;
      this.item = null;
      if (history.state && history.state.siLook) {
        history.replaceState(null, '', location.pathname + location.search);
      }
      setTimeout(() => { if (!this.dialog.open) this.body.replaceChildren(); }, 50);
    }

    updateBar() {
      const vis = this.visible();
      const pad = (n) => String(n).padStart(2, '0');
      const cur = this.dialog.querySelector('[data-dialog-current]');
      const tot = this.dialog.querySelector('[data-dialog-total]');
      if (cur) cur.textContent = pad(vis.indexOf(this.item) + 1);
      if (tot) tot.textContent = pad(vis.length);
      this.dialog.querySelectorAll('[data-look-prev], [data-look-next]').forEach((b) => {
        b.hidden = vis.length < 2;
      });
    }

    setupGallery(root = this.body) {
      const gallery = root.querySelector('[data-gallery]');
      const current = root.querySelector('[data-gallery-current]');
      if (!gallery || !current) return;
      gallery.addEventListener('scroll', () => {
        const frame = gallery.firstElementChild;
        const w = frame ? frame.getBoundingClientRect().width : gallery.clientWidth;
        if (w) current.textContent = Math.round(gallery.scrollLeft / w) + 1;
      }, { passive: true });
    }

    /* ---------------------------------------------------------- Købsboks */

    // Lookbook-visningen: købsboksen ligger i en skuffe over billedet
    toggleShop(open) {
      this.dialog.classList.toggle('is-shop-open', open);
      if (open) {
        const close = this.body.querySelector('.si-drawer__head [data-shop-close]');
        if (close) close.focus({ preventScroll: true });
      } else {
        const btn = this.body.querySelector('[data-shop-open]');
        if (btn) btn.focus({ preventScroll: true });
      }
    }

    // Trustpilot, betalingsbjælke og USP-rækker er rendret én gang i
    // [data-si-src]; hvert look får sin egen kopi
    fillDetail(detail) {
      const src = this.querySelector('[data-si-src]');
      const put = (slotSel, srcSel) => {
        const slot = detail.querySelector(slotSel);
        const node = src && src.querySelector(srcSel);
        if (slot && node) slot.replaceChildren(node.cloneNode(true));
        return slot;
      };
      put('[data-trust-slot]', '.uds-trustbar');
      put('[data-secure-slot]', '.sainte-secure');
      const usp = put('[data-usp-slot]', '.sainte-usp');
      const box = detail.querySelector('[data-buy]');
      // Produktsidens «Gratis totebag ved 2 longsleeves» hører ikke til i et
      // look: looket har sit eget tilbud, og to totebag-tilbud forvirrer
      const pdpOffer = usp && usp.querySelector('.sainte-offer');
      if (pdpOffer) pdpOffer.remove();
      if (box) this.updateBuy(box);
    }

    // Valgt størrelse = varen er med. Klik på den valgte igen fravælger varen.
    toggleSize(btn) {
      if (btn.disabled) return;
      const group = btn.closest('.si-sizes');
      const on = !btn.classList.contains('is-selected');
      group.querySelectorAll('.si-size').forEach((b) => {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      if (on) {
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
      }
      group.classList.remove('is-missing');
      this.updateBuy(btn.closest('[data-buy]'));
    }

    selectedItems(box) {
      return Array.from(box.querySelectorAll('.si-size.is-selected')).map((b) => ({
        id: Number(b.dataset.variant),
        price: Number(b.dataset.price),
        full: b.dataset.full !== 'false',
        role: (b.closest('.si-product') || { dataset: {} }).dataset.role || '',
      }));
    }

    // Look-tilbuddet gælder, når mindst én overdel og én underdel er valgt
    offerState(box, items) {
      if (box.dataset.offer !== 'true') return { on: false, qualified: false };
      const roles = items.map((i) => i.role);
      return { on: true, qualified: roles.includes('top') && roles.includes('bottom') };
    }

    // Procenten gælder kun varer til fuld pris (koden er begrænset til
    // «Fuld pris»), afrundet pr. linje som Shopify gør
    offerTotal(box, items) {
      const pct = Number(box.dataset.percent) || 0;
      return items.reduce((t, i) => t + (i.full ? Math.round(i.price * (100 - pct) / 100) : i.price), 0);
    }

    money(cents) {
      if (typeof window.sainteMoney === 'function') return window.sainteMoney(cents);
      const format = this.dialog.dataset.moneyFormat;
      if (typeof window.formatMoney === 'function' && format) return window.formatMoney(cents, format);
      return (cents / 100).toFixed(2).replace('.', ',') + ' DKK';
    }

    updateBuy(box) {
      if (!box) return;
      const btn = box.querySelector('[data-buy-look]');
      if (!btn) return;
      const items = this.selectedItems(box);
      const full = items.reduce((total, i) => total + i.price, 0);
      const offer = this.offerState(box, items);
      const sum = offer.qualified ? this.offerTotal(box, items) : full;
      const label = btn.querySelector('[data-buy-label]');
      const total = btn.querySelector('[data-buy-total]');
      const err = box.querySelector('[data-buy-error]');
      if (err) err.hidden = true;
      const article = box.closest('.si-detail');
      const barTotal = article && article.querySelector('[data-bar-total]');
      if (barTotal) barTotal.textContent = items.length ? this.money(sum) : '';
      box.classList.toggle('is-offer-qualified', offer.qualified);
      const gift = box.querySelector('[data-buy-gift]');
      const hint = box.querySelector('[data-buy-hint]');
      if (gift) gift.hidden = !offer.qualified;
      if (hint) hint.hidden = !offer.on || offer.qualified || !items.length;
      if (items.length) {
        label.textContent = this.dialog.dataset.labelBuy;
        if (offer.qualified && sum < full) {
          total.innerHTML = '<s class="si-buy__was">' + this.money(full) + '</s>' + this.money(sum);
        } else {
          total.textContent = this.money(sum);
        }
        btn.removeAttribute('aria-disabled');
      } else {
        label.textContent = this.dialog.dataset.labelChoose;
        total.textContent = '';
        btn.setAttribute('aria-disabled', 'true');
      }

      // Klarna-rækken følger lookets total, som på produktsiden (Math.floor,
      // så beløbet matcher Liquids heltalsdivision i skuffen dér)
      const part = box.querySelector('[data-klarna-part]');
      if (part) {
        const row = part.closest('.sainte-usp__row');
        if (row) row.hidden = sum < 35000;
        part.textContent = (Math.floor(sum / 3) / 100).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
      }
    }

    async buy(btn) {
      if (btn.classList.contains('loading')) return;
      const box = btn.closest('[data-buy]');
      const items = this.selectedItems(box);
      if (!items.length) {
        const group = box.querySelector('.si-sizes');
        if (group) {
          group.classList.remove('is-missing');
          void group.offsetWidth;
          group.classList.add('is-missing');
        }
        return;
      }

      const err = box.querySelector('[data-buy-error]');
      const detail = box.closest('.si-detail');
      const lookHandle = (detail && detail.dataset.handle) || '';
      const offer = this.offerState(box, items);
      const lines = items.map((i) => ({ id: i.id, quantity: 1, extra: {} }));
      if (offer.qualified && box.dataset.giftVariant) {
        lines.push({ id: Number(box.dataset.giftVariant), quantity: 1, extra: { _gave: 'look-tilbud' } });
      }
      btn.classList.add('loading');
      try {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          // Skjulte felter (understreg = vises ikke for kunden), så ordrerne
          // viser hvilke køb der kom fra et look, og hvorfra
          body: JSON.stringify({
            items: lines.map((l) => ({
              id: l.id,
              quantity: l.quantity,
              properties: Object.assign({
                _kilde: 'outfit-inspo',
                _look: lookHandle,
                _placering: this.dataset.source || '',
              }, l.extra),
            })),
          }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.description || data.message || '');
        // Rabatkoderne sættes på, så kunden aldrig skal skrive dem
        if (offer.qualified && box.dataset.codes) {
          await fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: box.dataset.codes }),
          }).catch(() => {});
        }
        this.closeForCart();
      } catch (e) {
        if (err) {
          err.textContent = (e && e.message) || this.dialog.dataset.labelError;
          err.hidden = false;
        }
      } finally {
        btn.classList.remove('loading');
      }
    }

    // Looket lukkes først, så kurv-appens skuffe ikke ligger bag dialogen
    closeForCart() {
      this.afterClose = () => this.openCart();
      this.requestClose();
      if (!this.dialog.open && this.afterClose) {
        const next = this.afterClose;
        this.afterClose = null;
        next();
      }
    }

    openCart() {
      const api = window.essentialCartApi;
      if (api && typeof api.refreshCart === 'function') {
        try { api.refreshCart(); } catch (e) { /* kurven henter selv ved åbning */ }
      }
      if (api && typeof api.openCart === 'function') {
        api.openCart();
        return;
      }
      document.dispatchEvent(new CustomEvent('essential-cart:open'));
      setTimeout(() => {
        const open = Array.from(document.documentElement.classList).some((c) => c.startsWith('essential-cart__') && c !== 'essential-cart__closed');
        if (!open) window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
      }, 800);
    }

    checkTall() {
      const info = this.body.querySelector('.si-detail__sticky');
      if (!info) return;
      info.classList.remove('is-static');
      const top = parseFloat(getComputedStyle(info).top) || 0;
      info.classList.toggle('is-static', info.offsetHeight > window.innerHeight - top);
    }
  });
}
